import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/resource/my-resource-empty.png'


const _withScopeId = n => (_pushScopeId("data-v-188724fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"min-height":"220px","padding-bottom":"30px"} }
const _hoisted_2 = { class: "website-item-check-cont" }
const _hoisted_3 = { class: "website-name" }
const _hoisted_4 = { style: {"padding":"0 20px 0 20px"} }
const _hoisted_5 = {
  key: 0,
  class: "empty-container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "empty-not-search" }, [
    /*#__PURE__*/_createElementVNode("p", null, "暂无可推送的站点")
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "btn-con" }

import ResourceDialog from '../resource-dialog.vue';
import {ref, watch} from 'vue';
import PublishDialogVue from './PublishDialog.vue';
import Message from '@/components/message/message.js';
type IPushAssetsSiteList = {
    dtBrand: string; // 品牌;
    dtTenant: string; // 空间;
    pushed: boolean; // 是否已推送;
    siteName: string;
}[];
type IBrandList = {
    siteName: string;
    dtBrand: string; // 品牌;
    dtTenant: string; // 空间;
    pushed: boolean; // 是否已推送;
    select: boolean;
    openScop: 'community_open' | 'personal';
}[];

type IPostData = {
    id: string;
    pushInfoList: {
        communityOpenInfo: {
            chooseCategoryOptionList: [
                {
                    categoryCode: string;
                    optionCode: string;
                    optionName: string;
                }
            ];
            // delayOpenTimeDuration: 0;
            // delayOpenTimeUnit: string;
            visibleTime: number;
        };
        dtBrand: string;
        dtTenant: string;
        openScop: 'community_open' | 'personal';
    }[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    id: { default: undefined },
    visible: { type: Boolean, default: false },
    dialogWidth: { default: 750 },
    isOverflow: { type: Boolean, default: true },
    showConfirmButton: { type: Boolean, default: true }
  },
  emits: ['update:visible', 'success'],
  setup(__props: any, { emit }) {

const props = __props as { id: string, visible: boolean, dialogWidth: number, isOverflow: boolean, showConfirmButton: boolean };




const pushFormList = ref([]);
const loading = ref(false);
const brandList = ref<IBrandList>([]);

watch(
    () => props.visible,
    async val => {
        if (val) {
            getBrandList();
        }
    }
);

// 获取可推送的站点列表
const getBrandList = async () => {
    loading.value = true;
    try {
        const res: {data: IPushAssetsSiteList} = await G_transmit(
            'getPushAssetSiteList',
            {queries: {id: props.id}}
        );
        const list = res.data.map(item => {
            return {
                ...item,
                select: false,
                openScop: 'community_open' as const
            };
        });
        brandList.value = list;
    } catch (error) {
        console.error(error);
    }
    loading.value = false;
};

// 推送确认
const handleConfirm = async () => {
    loading.value = true;
    if (brandList.value.filter(item => item.select).length === 0) {
        Message({type: 'info', text: '请先选择要推送的网站'});
        loading.value = false;
        return;
    }
    try {
        const validList: any[] = [];
        brandList.value.forEach((item, index) => {
            if (item.select) {
                validList.push(
                    // @ts-ignore
                    pushFormList.value[index].getParams()
                );
            }
        });
        const communityOpenInfoList = await Promise.all(validList);
        const siteInfoList: IPostData['pushInfoList'] = [];
        brandList.value
            .filter(item => item.select)
            .forEach((item, index) => {
                siteInfoList.push({
                    dtBrand: item.dtBrand,
                    dtTenant: item.dtTenant,
                    openScop: item.openScop,
                    communityOpenInfo: communityOpenInfoList[index]
                });
            });
        const params: IPostData = {
            id: props.id,
            pushInfoList: siteInfoList
        };
        const res = await G_transmit('pushResourceToOtherSite', {data: params});
        Message({type: 'success', text: '推送成功'});
        handleCancel();
        emit('success');
    } catch (error: any) {
        console.log('error', error);
        Message({
            type: 'info',
            text: error.message || error.status?.desc || '请将必填项填写完整'
        });
    }
    loading.value = false;
};

//
const handleCancel = () => {
    brandList.value = [];
    emit('update:visible', false);
};

//选中取消时重置是否私有
const selectChange = (item, value) => {
    if (!value) item.openScop = 'community_open';
};

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ResourceDialog, {
      visible: __props.visible,
      "is-no-padding": true,
      title: "推送到其他网站",
      width: props.dialogWidth,
      onOnClose: handleCancel,
      appendToBody: ""
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(brandList.value, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.dtBrand
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createVNode(_component_el_checkbox, {
                    modelValue: item.select,
                    "onUpdate:modelValue": ($event: any) => ((item.select) = $event),
                    onChange: 
                                    val => {
                                        selectChange(item, val);
                                    }
                                
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, _toDisplayString(item.siteName), 1)
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_radio_group, {
                  modelValue: item.openScop,
                  "onUpdate:modelValue": ($event: any) => ((item.openScop) = $event)
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: "community_open",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("公开")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: "personal",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("个人私有")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(PublishDialogVue, {
                  ref_for: true,
                  ref_key: "pushFormList",
                  ref: pushFormList,
                  id: props.id,
                  tenant: item.dtTenant,
                  brand: item.dtBrand,
                  scope: item.openScop,
                  isOverflow: props.isOverflow,
                  visible: item.select,
                  showConfirmButton: false
                }, null, 8, ["id", "tenant", "brand", "scope", "isOverflow", "visible"])
              ], 512), [
                [_vShow, item.select]
              ])
            ], 64))
          }), 128)),
          (brandList.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, loading.value]
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            class: "srt-el-button srt-el-button--cancel srt-el-button-h36",
            onClick: handleCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消 ")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "srt-el-button srt-el-button--primary srt-el-button-h36",
            onClick: handleConfirm,
            disabled: brandList.value.length === 0,
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "width"])
  ]))
}
}

})